import Axios from "axios"


export async function get_academy_info(props) {
    const branch_id = props['branch_id']
    const Set_academyInfo = props['Set_academyInfo']

    const result = await Axios
                    .post("/academy/info", {
                        branch_id: branch_id,
                    });
    const data = result['data']

    if(data['status'] === 'fail') {
        alert(data['message'])
    }
    else if(data['status'] === 'success') {
        await Set_academyInfo(data['data'])
    }
}